document.addEventListener("DOMContentLoaded", function () {

    const customer = window.shopifyCustomer;
    const token = localStorage.getItem("token");
    const apiUrl = window.shopifyConfig.apiUrl;
    const storeApiUrl = window.shopifyConfig.storeUrl;
    const storeAccessToken = window.shopifyConfig.storefrontAccessToken;
    const categoryOrder = JSON.parse(localStorage.getItem('recipeOrder')) || [];
    const contributorsOrder = JSON.parse(localStorage.getItem('contributorsOrder')) || [];
    const photoOrder = JSON.parse(localStorage.getItem('photoOrder')) || [];

    const savedOrder = {
        recipes: categoryOrder,
        photos: photoOrder,
        contributors: contributorsOrder
    };

    const isEmpty =
        (!savedOrder.recipes.length) &&
        (!savedOrder.photos.length) &&
        (!savedOrder.contributors.length);

    if (isEmpty) {
        // console.error('No saved order found in localStorage.');
        return;
    }

    //  Get previously saved version
    const lastSaved = localStorage.getItem("lastSavedOrder");

    //  Convert current data to string for comparison
    const currentData = JSON.stringify(savedOrder);

    if (lastSaved === currentData) {
        // console.log("No changes detected. Skipping API call.");
        return;
    }

    //  Proceed only if changed
    const formData = new FormData();
    formData.append("api", "categoriesJSON");
    formData.append("action", "add");
    formData.append("categories_json", currentData);
    formData.append("user_email", customer.email);

    fetch(apiUrl, {
        method: "POST",
        headers: { "Drupal-Access-Token": token },
        body: formData,
    })
    .then((res) => res.json())
    .then((data) => {
      if (data.status === 1) {
        // console.log("Categories saved successfully.");

        // ✅ Save latest version after success
        localStorage.setItem("lastSavedOrder", currentData);
      } else {
        // console.warn("Failed to save categories:", data);
      }
    })
    .catch((err) => {
      console.error("Error saving categories:", err);
    });
});
